import failAction from './failAction'
import requestAction from './requestAction'
import successAction from './successAction'
import loader from './loader'

export default {
  createFetchCurrentUserRequestAction: requestAction,
  createFetchCurrentUserSuccessAction: successAction,
  createFetchCurrentUserFailAction: failAction,
  createFetchCurrentUserLoader: loader,
}
